(() => {
  if (customElements.get('eil-app-banner')) return;
  customElements.define('eil-app-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const editor = this.dataset.editor === 'true';
      this.storageKey = `eil-app-banner-dismissed:${this.dataset.sectionId}`;
      if (!editor) {
        try { this.hidden = localStorage.getItem(this.storageKey) === '1'; } catch (_) {}
      }
      const link = this.querySelector('[data-app-link]');
      const ua = navigator.userAgent || '';
      const ios = /iPad|iPhone|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const target = ios ? this.dataset.ios : /Android/i.test(ua) ? this.dataset.android : '';
      if (link && target) link.href = target;
      this.querySelector('[data-app-close]')?.addEventListener('click', () => {
        this.hidden = true;
        if (!editor) { try { localStorage.setItem(this.storageKey, '1'); } catch (_) {} }
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.hidden = false;
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('is-ready');
            this.observer.disconnect();
          }
        }, { threshold: .15 });
        this.observer.observe(this);
      } else this.classList.add('is-ready');
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
})();
